import {View}           from 'backbone';
import BaseControlView  from 'BaseControlView.js';
import template         from 'report/control-gauge-chart.ejs';
import eventBus         from 'EventBus.js';
import util             from "util/Util.js";

class GaugeChartView extends BaseControlView {

    initialize(opts) {
        super.initialize(opts);
        this.template = template;
        this.tagName = 'div';
        this.options = opts || {};

        this.listenTo(eventBus, 'ButtonThemeChange', this.themeChangeRender);
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    get kind() {
        return 'GaugeChartView';
    }

    buildChart(ctx) {
        const currentValue = 33;
        var minValue = util.extractNum(this.model.get('minValue'));
        var maxValue = util.extractNum(this.model.get('maxValue'));


        var arcRadius = util.extractNum(this.model.get('width')) / 2;

        var w = util.extractNum(this.model.get('width')),
            h = util.extractNum(this.model.get('height')),
            context = ctx,
            x = w/2,
            y = h-20, // pad for labels
            r = arcRadius,
            radian = Math.PI/180;

        context.fillStyle = 'transparent';
        context.fillRect(0,0,w,h);

        var grd = context.createLinearGradient(x-100,y-100, w+50, y);
        const leftColor = this.model.get('dialLeftColor')   ? this.model.get('dialLeftColor')  : '#11F204';
        const rightColor = this.model.get('dialRightColor') ? this.model.get('dialRightColor') : '#CB632E';
        grd.addColorStop(0.2, util.enforceColorSyntax( leftColor ));
        grd.addColorStop(1,   util.enforceColorSyntax( rightColor ));

        context.beginPath();
        context.fillStyle = grd;
        context.moveTo(x,y);
        context.arc(x,y,r,180*radian, 360*radian, false);
        context.lineTo(x,y);
        context.closePath();
        context.fill();

        // inner arc
        r = Math.abs(arcRadius-65); // change radius

        context.beginPath();
        context.fillStyle = '#CECECE';
        context.moveTo(x,y);
        context.arc(x,y,r,180*radian, 360*radian, false);
        context.lineTo(x,y);
        context.closePath();
        context.fill();



        // Draw Marks on dial
        this.drawLargeTicks(context, x, y, arcRadius);
        this.drawSmallTicks(context, x, y, arcRadius);

        //draw needle
        var valuePercent = (currentValue * 100)/(maxValue - minValue);

        this.drawNeedle(context, x, y, arcRadius, valuePercent);

        //center needle circle
        r = 15;
        context.beginPath();
        context.fillStyle = '#000000';
        context.moveTo(x,y);
        context.arc(x,y,r,180*radian, 360*radian, false);
        context.lineTo(x,y);
        context.closePath();
        context.fill();

        // draw labels
        this.drawLabels(context, h, w, minValue, maxValue, currentValue);
    }

    drawLabels(ctx, h, w, minValue, maxValue, currentValue) {
    ctx.font = '16px Sans Serif';
    ctx.fillStyle = '#000000';
    ctx.textAlign = 'left';
    ctx.fillText(minValue, 0, h);

    ctx.textAlign='right';
    ctx.fillText(maxValue, w, h);

    ctx.textAlign='center';
    ctx.fillText(currentValue, (w/2), h);

}

    drawNeedle(context, x, y, r, valuePercent) {
    // find outer x,y based on value (percent)
    var a = ((valuePercent * 180) / 100) + 180;
    var radian = Math.PI/180;
    var markX = x + r * Math.cos(radian * a);
    var markY = y + r * Math.sin(radian * a);

    const needleLength = Math.sqrt( (markX-x)*(markX-x) + (markY-y)*(markY-y) );


    const needleColor = this.model.get('needleColor') ? this.model.get('needleColor') : '#312AE3';
    context.stokeStyle = needleColor;
    context.fillStyle = needleColor;
    context.lineWidth = 1;

    var startRadians=Math.atan((markY-y)/(markX-x));
    startRadians+=((markX>x)?-270:270)*Math.PI/180;
    this.drawArrowhead(context, markX, markY, x,y,startRadians, needleLength);

}

    drawArrowhead(ctx,x,y,x2,y2,radians, length) {
    ctx.save();
    ctx.beginPath();
    ctx.translate(x,y);
    ctx.rotate(radians);
    ctx.moveTo(0,0);
    ctx.lineTo(5,20);
    ctx.lineTo(0,length);
    ctx.lineTo(-5,20);
    ctx.closePath();
    ctx.restore();
    ctx.fill();
}

    drawSmallTicks(context, x, y, r) {
    var skipTicks = [1,6,11,16,21,26,31,36,41,46, 51];
    let tickCount = 1;

    for (var a = 180; a < 360; a+=3.6) {
        var radian = Math.PI/180;

        var i = $.inArray(tickCount, skipTicks);
        if (i === -1) {

            var markX = x + r * Math.cos(radian * a);
            var markY = y + r * Math.sin(radian * a);

            context.beginPath();
            context.moveTo(markX, markY);

            // determine x,y by length
            var distance = 1;
            //				const d = Math.sqrt(Math.abs((x-markX))^2 + Math.abs((y-markY))^2);
            //				var t = distance / d;
            const d = 12;
            const t = 0.08;
            var xt = ((1-t) * markX + t*x);
            var yt = ((1-t) * markY + t*y);



            //console.log('draw to ' + xt + ', ' + yt + '  d=' + d + '   t=' + t);
            context.lineTo(xt,yt);
            context.stroke();
        }
        tickCount++;

    }


}

    drawLargeTicks(context, x, y, r) {
    let tickCount = 1;

    for (var a = 180; a < 360; a+=18) {
        if (tickCount > 1) {
            var radian = Math.PI/180;
            var lineLength = 10;

            var markX = x + r * Math.cos(radian * a);
            var markY = y + r * Math.sin(radian * a);

            context.beginPath();
            context.moveTo(markX, markY);

            // determine x,y by length
            var distance = 2;
            //const d = Math.sqrt(Math.abs((x-markX))^2 + Math.abs((y-markY))^2);
            //var t = distance / d;
            // need to make d / t constant values, too much variance
            const d = 15;
            const t = 0.13;
            var xt = ((1-t) * markX + t*x);
            var yt = ((1-t) * markY + t*y);




            context.lineTo(xt,yt);
            context.stroke();
        }
        tickCount++;


    }


}

    render() {
        console.log('chart render ' + this.id);
        super.render();

        var c = $('#' + this.model.get('id') + ' canvas');
        const ctx = c[0].getContext('2d');

        this.buildChart(ctx);

        return this;
    }


}

export default GaugeChartView;
